export default "__VITE_ASSET__CEYsA2ML__"